

export default function ArrowRightBtn() {
  return (
    <div className="">
      <i className="fa-solid fa-angle-right "></i>
    </div>
  );
}
